import { css } from '@emotion/react';

export const VideoPanelStyles = css`
	flex-shrink: 0;
	user-select: none;
	z-index: 100000;

	.control-buttons-container {
		display: flex;
		justify-content: center;
		width: 100%;
	}

	.control_buttons {
		bottom: 5%;
		margin: 0 auto;
		position: absolute;
		z-index: 1;
	}

	.remote_video {
		align-items: center;
		background-color: #4c4c4c;
		display: flex;
		justify-content: center;
		max-width: 100%;
		position: relative;
		width: 700px;

		&_muted {
			background-color: black;
			font-size: 30px;
			justify-content: center;
		}

		&__text_camera-muted {
			color: white;
		}

		& > video {
			max-height: 100%;
			width: 100%;
		}

		& > span {
			color: white;
			position: absolute;
			size: 30px;
		}
	}

	.local_video {
		height: 24%;
		max-width: 34%;
		overflow: hidden;
		position: absolute;
		z-index: 1;

		.local-video-hidden & {
			display: none;
		}

		video {
			max-height: 100%;
			max-width: 100%;
		}

		& > video.video_reflected {
			transform: scale(-1, 1);
		}

		& > div {
			align-items: center;
			color: white;
			display: flex;
			font-size: 1.5vh;

			@media (max-width: 500px) {
				font-size: 0.9vh;
			}

			height: 100%;
			justify-content: center;
			padding-left: 1px;
			padding-right: 1px;
			position: absolute;
			text-align: center;
			width: 100%;
			z-index: 14444;
		}
	}

	@media (min-width: 1000px) {
		&,
		.remote_video {
			height: 100%;
			width: 100%;
		}

		.local_video {
			right: 10px;
			top: 15px;
		}
	}

	@media (max-width: 1000px) {
		height: 30vh;
		position: relative;

		.remote_video {
			height: 100%;

			& > video {
				height: 100%;
			}
		}

		.control_buttons {
			bottom: 17px;
		}

		.local_video {
			border: 0;
			display: block;
			right: 6px;
			top: 6px;
		}
	}

	&.video-panel_fullscreen {
		height: 100%;
		left: 0;
		position: fixed;
		top: 0;
		width: 100%;

		.remote_video {
			height: 100%;
			width: 100%;

			video {
				height: 100%;
				width: initial;
			}
		}

		.local_video {
			height: 25vh;
			max-width: 33.5vh;
		}

		.local_video > div {
			font-size: 2vw;
		}
	}
`;
